import React, { useState } from 'react';
import ReceivedTo from '../ReceivedTo';
import DateRange from '../DateRange';
import Button from '../../../components/Button';
import Typography from '../../../components/Typography';
import COLORS from '../../../util/constants/colors';

const FilterBox = ({
  ownerContacts,
  selectedRecipients,
  setSelectedRecipients,
  dateRange,
  setDateRange,
  fetchReferralStats,
  clearParams,
}) => {
  const [currentDateRange, setCurrentDateRange] = useState(dateRange);
  const [currentSelectedRecipients, setCurrentSelectedRecipients] = useState(selectedRecipients);

  const getDateRangeText = () => {
    if (dateRange.startDate === null && dateRange.endDate === null) {
      return 'Last 7 days';
    } else if (dateRange.startDate === null && dateRange.endDate !== null) {
      return `7 days up to ${dateRange.endDate}`;
    } else if (dateRange.startDate !== null && dateRange.endDate === null) {
      return `${dateRange.startDate} to Now`;
    } else {
      return `${dateRange.startDate} to ${dateRange.endDate}`;
    }
  };

  const updateStats = () => {
    setCurrentDateRange(dateRange);
    setCurrentSelectedRecipients(selectedRecipients);
    fetchReferralStats();
  };

  return (
    <div className="filter-box">
      <div className="filters">
        <ReceivedTo
          ownerContacts={ownerContacts}
          selectedRecipients={selectedRecipients}
          setSelectedRecipients={setSelectedRecipients}
        />
        <DateRange
          dateRange={dateRange}
          setDateRange={setDateRange}
          setSelectedRecipients={setSelectedRecipients}
          updateStats={fetchReferralStats}
        />
      </div>
      <div className='bottom'>
        <Typography variant="text" size="xxsmall" color={COLORS.TEXT_TERTIARY_LITE}>
          Viewing data from &nbsp;
          <Typography variant="text" size="xxsmall" color={COLORS.TEXT_TERTIARY_LITE} bold>
            {getDateRangeText()}
          </Typography>
        </Typography>
        <div className='actions'>
          <Button
            label="Clear"
            size="xxsmall"
            type="secondary"
            onClick={clearParams}
          />
          <Button
            label="Update"
            size="xxsmall"
            type="primary"
            onClick={updateStats}
            disabled={
              currentDateRange.startDate === dateRange.startDate &&
              currentDateRange.endDate === dateRange.endDate &&
              currentSelectedRecipients.length === selectedRecipients.length &&
              currentSelectedRecipients.every((recipient) => selectedRecipients.includes(recipient))
            }
          />
        </div>
      </div>
    </div>
  );
};

export default FilterBox;
